<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Driver Payroll Summary Report</span><br/>
      <span style="font-style: italic; font-size: 18px">this report shows total HOS hours by driver & date</span>
      <div style="font-style: italic; font-size: 18px">'Get Results' returns saved results if found or runs the report. Use the refresh icon next to the result time to pull the latest data.</div>
    </div>

    <div style="position: relative; font-weight: bold; font-size: 24px" class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
      &nbsp;to&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
      &nbsp;<a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;|&nbsp;&nbsp;
      <span v-if="driver_options.length > 0">
        Driver:&nbsp;<b-form-select v-model="selected_driver" :options="driver_options" style="font-size: 20px; font-weight: bold; width:230px"/>
        &nbsp;&nbsp;|&nbsp;&nbsp;
      </span>
      <b-button v-on:click.prevent="load_data(false)" :disabled="loading">Get Results</b-button>
      &nbsp;&nbsp;|&nbsp;&nbsp;
      <b-button size="md" variant="success" :disabled="loading" @click="download">Download Report</b-button>
    </div>
    <div v-if="results_cached_at" class="text-center mt-1" style="font-size: 14px; color: #888;">
      Using data from {{ formattedCachedAt }}
      — <a href="#" @click.prevent="load_data(true)" style="font-size: 14px;">Pull New Data</a>
    </div>

    <div v-if="polling" class="mt-3 p-3 border rounded bg-light d-flex align-items-center justify-content-center">
      <b-spinner style="width: 3rem; height: 3rem;" class="mr-3" label="Loading..."></b-spinner>
      <span>
        <template v-if="!email_opt_in_sent">
          Report is still generating. Stay put, or <a href="#" @click.prevent="optInEmailWhenReady">get an in-app notification when it's done</a>.
        </template>
        <template v-else>
          Report is still generating. You'll get an in-app notification when it's done.
        </template>
      </span>
    </div>

    <div v-if="!loading && display_items.length > 0">
      <div class="row" style="margin:30px; font-weight: bold; font-size: 24px;">
        <div v-if="summary.total_cnt" class="col" style="border: 1px solid grey;">{{display_items.length}} of {{summary.total_cnt}}</div>
        <div v-if="summary.views_reports_driver_payroll_minimum_hours" class="col" style="border: 1px solid grey;">Min Hrs: {{summary.views_reports_driver_payroll_minimum_hours}}</div>
        <div v-if="summary.views_reports_driver_payroll_middle_day_min_hours" class="col" style="border: 1px solid grey;">Middle Day Min Hrs: {{summary.views_reports_driver_payroll_middle_day_min_hours}}</div>
      </div>
    </div>

    <table v-if="!loading && display_items.length > 0" width="100%" border="1">
      <thead>
        <tr>
          <th width="20px"></th>
          <th width="150px">Driver</th>
          <th v-if="summary.views_reports_payroll_summary_samsara_username_enabled" width="120px">Samsara Username</th>
          <th v-for="date in summary.dates">{{date}}</th>
          <th width="150px">Total Hours</th>
        </tr>
      </thead>
      <template v-for="item in display_items">
        <tr>
          <td><b-button v-if="selected_driver" size="sm" @click="toggle_div(item,'isDetailsVisible')">{{ item.isDetailsVisible ? '-' : '+' }}</b-button></td>
          <td style="font-weight: bold">{{item.driver}}<a v-if="item.driver_hos_link" target="_blank" :href="item.driver_hos_link"><img style="margin: 0px 5px 5px 5px" src="/driver-icon.png"/></a></td>
          <td v-if="summary.views_reports_payroll_summary_samsara_username_enabled">{{item.samsara_username}}</td>
          <td v-for="result in item.date_results">{{result.total_hrs}}</td>
          <td style="font-weight: bold">{{item.total_hrs}}</td>
        </tr>
        <tr style="border:3px solid var(--fi-rail-accent);" v-if="item.isDetailsVisible" v-for="date_result in item.date_results">
          <template v-if="date_result.hos_results && date_result.hos_results.length > 0 || date_result.booking_results && date_result.booking_results.length > 0">
            <td :colspan="item.date_results.length + 3 + (summary.views_reports_payroll_summary_samsara_username_enabled ? 1 : 0)">
              <h5 style="margin-top:8px">{{date_result.date}}</h5>
              <table v-if="date_result.hos_results && date_result.hos_results.length > 0 || date_result.booking_results && date_result.booking_results.length > 0" width="100%" border="1" style="font-size: 18px">
                <tr>
                  <th>Event</th>
                  <th>Vehicle</th>
                  <th>Start Time</th>
                  <th>Finish Time</th>
                  <th>Hours</th>
                </tr>
                <tr v-for="log in date_result.booking_results">
                  <td>Planned Times</td>
                  <td>{{log.vehicle}}</td>
                  <td>{{log.plannedStartDateTime | formatDateTimeSmall}}</td>
                  <td>{{log.plannedFinishDateTime | formatDateTimeSmall}}</td>
                  <td>{{log.plannedHours}}</td>
                </tr>
                <tr v-for="log in date_result.hos_results">
                  <td>Calculated HOS Times</td>
                  <td>{{log.vehicle}}</td>
                  <td>{{log.actualHOSStartDateTime | formatDateTimeSmall}}</td>
                  <td>{{log.actualHOSFinishDateTime | formatDateTimeSmall}}</td>
                  <td>{{log.hosHours}}</td>
                </tr>
              </table>
              <h5 style="margin-top:8px">HOS Log Events</h5>
              <table v-if="date_result.hos_results && date_result.hos_results.length > 0" width="100%" border="1" style="font-weight: bold; font-size: 12px;">
                <tr>
                  <td>Off Duty</td>
                  <template v-for="log in date_result.hos_logs">
                    <td :style="log.type=='offDuty' ? 'background-color:hsla(357,78%,65%,0.3)': ''"><span v-if="log.type=='offDuty'">{{log.logStartTime | formatTimeXS}}</span></td>
                  </template>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <td>On Duty</td>
                  <template v-for="log in date_result.hos_logs">
                    <td :style="log.type=='onDuty' ? 'background-color:hsla(190,70%,50%,0.3)' : ''"><span v-if="log.type=='onDuty'">{{log.logStartTime | formatTimeXS}}</span></td>
                  </template>
                  <td>{{date_result.total_onduty}}hrs</td>
                </tr>
                <tr>
                  <td>Driving</td>
                  <template v-for="log in date_result.hos_logs">
                    <td :style="log.type=='driving' ? 'background-color:hsla(120,100%,75%,0.3)': ''"><span v-if="log.type=='driving'">{{log.logStartTime | formatTimeXS}}</span></td>
                  </template>
                  <td>{{date_result.total_driving}}hrs</td>
                </tr>
                <tr>
                  <td>Duration</td>
                  <template v-for="log in date_result.hos_logs">
                    <td style="font-weight: bold; font-style: italic">{{log.duration}}</td>
                  </template>
                </tr>
                <tr>
                  <td>Vehicle</td>
                  <template v-for="log in date_result.hos_logs">
                    <td style="font-weight: bold; font-style: italic">{{log.vehicle}}</td>
                  </template>
                </tr>
                  <tr>
                    <td>Remark</td>
                    <template v-for="log in date_result.hos_logs">
                      <td>{{ log.remark }}</td>
                    </template>
                  </tr>
              </table>
              <br/>
            </td>
          </template>
        </tr>
      </template>
      <tr style="font-weight: bold; font-size: 18px">
        <td></td>
        <td>Totals</td>
        <td v-if="summary.views_reports_payroll_summary_samsara_username_enabled"></td>
        <td v-for="result in display_date_totals">{{result}}</td>
        <td>{{display_total_hrs}}</td>
      </tr>
    </table>
    <div v-if="loading && !polling">
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>
  </div>

</template>
<script>
import {api_url, get_driver_list, get_actuals_payroll_summary_report, register_email_when_ready} from '../networking/apis'
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'
import axios from "axios";

export default {
  name: 'actuals_payroll_summary_report',

  components: {
  },

  data() {
    return {
      items: [],
      summary: [],
      loading: false,
      results_cached_at: null,
      polling: false,
      email_opt_in_sent: false,
      selected_driver: '',
      driver_options: [],
      details_fromDate: justDate(moment().subtract(7, 'days')),
      details_toDate: justDate(moment().subtract(1, 'days')),

      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(180, 'days'),
        maxDate: moment().add(1, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
    }
  },
  created() {
    this.load_drivers()
  },
  methods: {
    async load_drivers() {
      this.driver_options = []
      try {
        const {value: {data = []}} = await get_driver_list(this.user.tenant)
        this.driver_options = data
      } catch(e) {
        this.$emit('showAlert', 'error loading data, try logging in again or contact support if needed', 'danger', 5000)
      }
    },
    // FI-1432: user opts in to receive an email when this long-running report
    // finishes. matched server-side by (username, report_type) — the first
    // report_complete of this type after registration fires the email.
    async optInEmailWhenReady() {
      try {
        await register_email_when_ready({
          tenant: this.user.tenant,
          report_type: 'driver_payroll_report',
          params: {
            driver: this.selected_driver,
            from_date: this.details_fromDate,
            to_date: this.details_toDate,
          },
        })
        this.email_opt_in_sent = true
      } catch (e) {
        this.$emit('showAlert', "couldn't save the notification preference — try again", 'danger', 4000)
      }
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    async load_data(reprocess) {
      if (this._retryTimerId) { clearTimeout(this._retryTimerId); this._retryTimerId = null }
      if (this._pollingTimerId) { clearTimeout(this._pollingTimerId); this._pollingTimerId = null }
      this.loading = true
      this.results_cached_at = null
      if (!this.polling) {
        this._pollingTimerId = setTimeout(() => { this._pollingTimerId = null; this.polling = true }, 30000)
      }
      try {
        const {value: {data = []}} = await get_actuals_payroll_summary_report(this.user.tenant, this.selected_driver, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'), moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'), reprocess, this.polling ? { timeout: 30000, poll: true } : {})
        if (this._pollingTimerId) { clearTimeout(this._pollingTimerId); this._pollingTimerId = null }
        if (data.status === 'processing') {
          this._retryTimerId = setTimeout(() => { this._retryTimerId = null; this.load_data(false) }, 10000)
          return
        }
        this.polling = false
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.results_cached_at = data.results_cached_at || null
        this.loading = false
      } catch (e) {
        if (this._pollingTimerId) { clearTimeout(this._pollingTimerId); this._pollingTimerId = null }
        this.polling = true
        this.loading = false
        this._retryTimerId = setTimeout(() => { this._retryTimerId = null; this.load_data(false) }, 30000)
      }
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    async download(){
      this.$emit('showAlert', 'processing download request', 'info')
      axios.defaults.headers.common.Accept = {}
      axios.post(
          `${api_url}bookings/reports/actuals/payroll/summary/download`,
          {
            tenant: this.user.tenant,
            selected_driver: this.selected_driver,
            fromDate: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            toDate: moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwt')}`,
              Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'blob'
          }
      ).then((response) => {
        axios.defaults.headers.common.Accept = 'application/json'
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
            'download',
            `payroll-driver-${this.details_fromDate}-${this.details_toDate}.csv`
        )
        document.body.appendChild(link)
        link.click()
        this.$emit('showAlert', 'download complete', 'success', 5000)
      }).catch(e => {
        axios.defaults.headers.common.Accept = 'application/json'
        this.$emit('showAlert', 'data could not be downloaded.', 'danger')
      })
    },
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    formattedCachedAt() {
      if (!this.results_cached_at) return ''
      const m = moment(this.results_cached_at)
      return m.isValid() ? m.format('MMM D, YYYY h:mm A') : this.results_cached_at
    },
    selected_driver_name() {
      if (!this.selected_driver) return null
      const opt = this.driver_options.find(d => String(d.value) === String(this.selected_driver))
      return opt ? opt.text : null
    },
    display_items() {
      if (!this.selected_driver || !this.selected_driver_name) return this.items
      return this.items.filter(item => item.driver === this.selected_driver_name)
    },
    display_date_totals() {
      if (!this.selected_driver || !this.display_items.length) {
        return this.summary.date_totals || []
      }
      const dates = this.summary.dates || []
      return dates.map(dateStr => {
        let sum = 0
        for (const item of this.display_items) {
          const dateResult = (item.date_results || []).find(r => r.date === dateStr)
          if (dateResult) sum += parseFloat(dateResult.total_hrs) || 0
        }
        return String(Math.round(sum * 100) / 100)
      })
    },
    display_total_hrs() {
      if (!this.selected_driver || !this.display_items.length) {
        return this.summary.total_hrs
      }
      const sum = this.display_items.reduce((acc, item) => acc + (parseFloat(item.total_hrs) || 0), 0)
      return String(Math.round(sum * 100) / 100)
    },
  },
  beforeDestroy() {
    if (this._retryTimerId) clearTimeout(this._retryTimerId)
    if (this._pollingTimerId) clearTimeout(this._pollingTimerId)
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.items = []
        this.summary = null
        this.load_drivers()
      }
    },
  }
}
</script>

<style scoped>

thead {
  position: sticky;
  top: 0;
  background-color: #F9F8F8;
  border: 1px solid black;
}

tr:nth-child(even) {
  background-color: #f2f2f2 !important;
}

.arrows {font-size: 22px; font-weight: bold; color: var(--fi-rail-accent) !important }


</style>
